import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M7 21h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "14", x: "2", y: "3", rx: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Tv2";
const Tv2 = memo(themed(Icon));
export {
  Tv2
};
//# sourceMappingURL=tv-2.js.map
